<script setup lang="ts">
import { Globe } from 'lucide-vue-next';

const { locale, locales, setLocale } = useI18n();
const showDropdown = ref(false);

const languages: Record<string, string> = {
  'en-US': 'English',
  'es-ES': 'Español',
};

const switchLanguage = (newLocale: 'en-US' | 'es-ES') => {
  setLocale(newLocale);
  showDropdown.value = false;
};

// Close dropdown when clicking outside
const handleClickOutside = () => {
  showDropdown.value = false;
};

onMounted(() => {
  if (showDropdown.value) {
    document.addEventListener('click', handleClickOutside);
  }
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});

watch(showDropdown, (newVal) => {
  if (newVal) {
    document.addEventListener('click', handleClickOutside);
  }
  else {
    document.removeEventListener('click', handleClickOutside);
  }
});
</script>

<template>
  <div class="relative">
    <SBButton
      variant="ghost"
      :lucide-icon="Globe"
      :label="languages[locale]"
      @click.stop="showDropdown = !showDropdown"
    />

    <div
      v-if="showDropdown"
      class="absolute bottom-full left-0 mb-1 w-full overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black/5"
    >
      <button
        v-for="lang in locales"
        :key="lang.code"
        class="w-full px-3 py-2.5 text-left text-sm transition-colors hover:bg-neutral-50"
        :class="{ 'bg-emerald-50 font-medium text-emerald-700': locale === lang.code }"
        @click.stop="switchLanguage(lang.code)"
      >
        <div class="flex items-center justify-between">
          <span>{{ languages[lang.code] }}</span>
          <span v-if="locale === lang.code" class="text-emerald-600">✓</span>
        </div>
      </button>
    </div>
  </div>
</template>
